import React from 'react';
import PropTypes from 'prop-types';

import styles from './DomainLabelNew.scss';

const DomainLabelNew = ({text, backgroundColor, textColor, inSearchResult}) => {

	const innerStyles = {
		backgroundColor: backgroundColor,
		color: textColor
	}

	return (
		<span className={`${inSearchResult === true ? styles.inSearchResult : styles.label}`}
			  style={innerStyles}>{text}</span>
	)
};

DomainLabelNew.defaultProps = {
	inSearchResult: false
}

DomainLabelNew.propTypes = {
	text: PropTypes.string.isRequired,
	backgroundColor: PropTypes.string.isRequired,
	textColor: PropTypes.string.isRequired,
	inSearchResult: PropTypes.bool,
};
export default DomainLabelNew;